module.exports = __webpack_public_path__ + "static/media/openai.6edf75ae.png";